import React from 'react';

// Types
import { WidthType } from 'Wpds/components/dropdown';

// Components
import WpSelectV2 from 'Wpds/components/select/WpSelectV2';
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpCheckbox } from 'Wpds/components/checkbox';

type Props = {
  addFilter: Function;
  handleRemoveFilter: Function;
  selectedFilters: Array<any>;
};

const StatusFilter = ({ addFilter, handleRemoveFilter, selectedFilters }: Props) => {
  const options = [
    { label: 'No Status', value: 'no_status' },
    { label: 'On Track', value: 'on_track' },
    { label: 'At Risk', value: 'at_risk' },
    { label: 'Achieved', value: 'achieved' },
    { label: 'Missed', value: 'missed' },
  ];

  const appliedFilters = selectedFilters.filter(filter => filter.type === 'status');
  const appliedFiltersLabels = appliedFilters.map(filter => filter.label);
  const hasAppliedFilters = appliedFilters.length > 0;

  const handleUpdateFilter = ({ label, value }) => {
    const isApplied = appliedFilters.find(filter => filter.statusId === value);
    if (isApplied) {
      handleRemoveFilter(isApplied);
    } else {
      addFilter({ type: 'status', label: label, statusId: value });
    }
  };

  const CustomInnerDropdown = () => {
    return (
      <WpButton variant={hasAppliedFilters ? 'primary' : 'tertiary'} size="sm" square slimPadding>
        Status {hasAppliedFilters && <>({appliedFilters.length})</>}
        <WpIcon name="angle-down" />
      </WpButton>
    );
  };

  const CustomOption = ({ option }) => {
    return (
      <WpCheckbox
        id={`status-filter-option-cb-${option.value}`}
        label={option.label}
        checked={appliedFiltersLabels.includes(option.label)}
      />
    );
  };

  return (
    <WpSelectV2
      id="status-filter"
      label="Status Filter"
      labelHidden
      options={options}
      components={{ option: CustomOption, innerDropdown: CustomInnerDropdown }}
      onChange={handleUpdateFilter}
      closeOnClick={false}
      optionsWidth={WidthType.fitWidth}
    />
  );
};

export default StatusFilter;
